import React from "react";
import { Contract } from "@/types";
import CTA from "@/components/atoms/CTA";
import { useTranslation } from "react-i18next";
import { useModal } from "@/contexts/ModalContext";
import { useOpenCreateContract } from "@/hooks/useGuardedWizards";
import { useTradeLock } from "@/hooks/useTradeLock";
import { getContractParties } from "@/utils/Contracts";

const RenewContractButton = ({ contract }: { contract: Contract }) => {
  const { t } = useTranslation();
  const { openModal } = useModal();
  const open = useOpenCreateContract();
  const { guardTradeLock } = useTradeLock();

  const parties = () => getContractParties(contract);

  // Guarded at the button rather than at the confirmation's primaryAction: GlobalModal calls closeModal()
  // immediately after an action fires, which would swallow a modal opened from inside it.
  const handleToggleOfArchive = guardTradeLock(() => {
    openModal({
      title: t("notifications:contracts.confirmContractRenewalTitle"),
      content: "", //t("notifications:contracts.confirmContractRenewalContent"),
      type: "confirmation",
      primaryAction: {
        onClick: async () => {
          open(contract.id);
        },
        text: t("actions:renewContract"),
        intent: "affirm",
      },
      secondaryAction: {
        onClick: () => {
          // just close it
        },
        text: t("actions:cancel"),
        intent: "negate",
      },
    });
  }, parties);

  return (
    <CTA
      size="sm"
      onClick={() => handleToggleOfArchive()}
      data-testid={"renew-contract-btn"}
      intent="secondary"
      tt="uppercase"
    >
      {t("actions:renewContract")}
    </CTA>
  );
};

export default RenewContractButton;
